<template>
  <div>
    <div class="bg">
      <div style="padding-bottom: 30px">
        <FxedTop></FxedTop>
      </div>
    </div>
    <!-- <div class="navbar">
        <div
          v-for="(item, index) in navList"
          :key="index"
          :class="item.isShow ? 'active' : 'item'"
          @click="handleNavList(item, index)">
          {{ item.title }}
          <div v-if="item.isShow" class="line"></div>
        </div>
      </div> -->
    <div class="pageTitle">
      <div class="sort"></div>
      <div class="currentLocation">当前位置：首页 > 下载专区</div>
    </div>

    <div class="mian">
      <div class="container">
        <div>
          <div class="navbar" style="margin-bottom: 20px">
            <div
              v-for="(item, index) in navList"
              :key="index"
              :class="item.isShow ? 'active' : 'item'"
              @click="handleNavList(item, index)">
              {{ item.title }}
              <div v-if="item.isShow" class="line"></div>
            </div>
          </div>

          <el-table
            :data="activities"
            style="width: 100%; margin-bottom: 20px"
            size="small">
            <el-table-column prop="title" label="标题"></el-table-column>
            <el-table-column prop="articleDesc" label="描述"> </el-table-column>
            <el-table-column
              prop="address"
              label="操作"
              align="center"
              width="100">
              <template v-slot="scope">
                <el-button type="mini" @click="handleEdit(scope.row, true)">
                  下载
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="display: flex; justify-content: flex-end">
            <el-pagination
              :page-size="pageSize"
              background
              layout="prev, pager, next"
              :total="total"
              @current-change="currentChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import FxedTop from "@/components/FxedTop";
import Footer from "@/components/Footer.vue";
import * as cmsApi from "@/api/cms";
export default {
  components: {
    Footer,
    FxedTop,
  },
  data() {
    return {
      loading: true,
      activities: [],
      total: 0,
      pageSize: 5,
      navList: [
        {
          title: "下载专区",
          isShow: true,
        },
        // {
        //   title: "动态新闻",
        //   isShow: false,
        // },
        // {
        //   title: "相关政策",
        //   isShow: false,
        // },
      ],
      type: 1,
    };
  },
  created() {
    console.log(this.$route.query.type);
    this.type = this.$route.query.type;
    if (this.$route.query.type == 1) {
      this.navList[0].isShow = true;
    }
    if (this.$route.query.type == 2) {
      this.navList[1].isShow = true;
    }
    if (this.$route.query.type == 3) {
      this.navList[2].isShow = true;
    }
    this.getIndex();
  },
  methods: {
    handleNavList(item, index) {
      this.navList.forEach((item) => {
        item.isShow = false;
      });
      this.type = index + 1;
      item.isShow = true;
      this.loading = true;
      this.total = 0;
      this.activities = [{}, {}, {}, {}];

      this.getIndex(1);
    },
    currentChange(envt) {
      console.log(envt);
      this.loading = true;
      this.getIndex(envt);
    },
    async getIndex(pageNum) {
      try {
        let article = [];
        article = await cmsApi.getArticleType({
          pageNo: pageNum,
          pageSize: this.pageSize,
          columnId: "1950564896112836610",
          moduleId: "1862788454765211699",
          type: 5,
        });
        this.activities = article.result.list;
        this.total = article.result.total;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleEdit(row) {
      if (row.attachmentLink) {
        window.open(row.attachmentLink);
      } else {
        this.$message.warning("暂无附件");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.noticeItem {
  .list {
    display: flex;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px dashed #e1e1e1;
    .yy {
      width: 75px;
      height: 76px;
      background: linear-gradient(#41a0f1 0%, #0a5b9f 100%);
      text-align: center;
      margin-right: 20px;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .dd {
        width: 75px;
        height: 25px;
        padding-top: 4px;

        font-size: 26px;
        margin-bottom: 10px;
      }
      .mm {
        font-weight: 500;
        font-size: 12px;
      }
    }
    .title {
      font-size: 20px;
      color: #4a4a4a;
      letter-spacing: 1px;
      // 超出1行显示...
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
      margin-bottom: 10px;
      cursor: pointer;
    }
    .text {
      height: 46px;

      font-size: 16px;
      color: #9b9b9b;
      // 超出2行显示...
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
</style>
